module.exports = __webpack_public_path__ + "img/close.f9ced72a.svg";